module.exports = __webpack_public_path__ + "static/media/flightboard-icon-dark.0ff57bba.png";